import { onMounted, onUnmounted } from 'vue';

export const useEventListener = (
    event: string,
    callback: EventListenerOrEventListenerObject,
    target?: Node | Window,
    options?: EventListenerOptions,
): void => {
    if (!target) {
        target = document;
    }
    onMounted(() => {
        target!.addEventListener(event, callback, options);
    });
    onUnmounted(() => {
        target!.removeEventListener(event, callback, options);
    });
};
